import { plantApi } from 'api/plantApi';
import { useAppDispatch, useAppSelector } from 'app/hooks';
import { selectPlantItemSidebar } from 'components/Common/Sidebar/sidebarSlice';
import { objectDataToday, ResponseData } from 'models';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { formatArray, formatToday, performanceList } from 'utils/common';
// import style from './AreaPerformance.module.scss'
import style from '../AreaActivePower/AreaActivePower.module.scss';
import ChartPerformance from '../ChartPerformance/ChartPerformance';
interface AreaPerformanceProps {}

export default function AreaPerformance(props: AreaPerformanceProps) {
  const plantItemSelected = useAppSelector(selectPlantItemSidebar);
  const dispatch = useAppDispatch();
  // const [date, setDate] = useState(moment().format('YYYY-MM-DD'));
  // const date : string = moment().format('YYYY-MM-DD');
  const [output_e, setOutput_e] = useState<number>(0);
  const [estimated_e, setEstimated_e] = useState<number>(0);
  const [performance_ratio, setPerformance_ratio] = useState<number>(0);
  const [dataChart, setDataChart] = useState<objectDataToday>();
  const [dateTime, setDateTime] = useState(moment().format('YYYY-MM-DD'));
  const [isTitle, setIsTitle] = useState('week');

  useEffect(() => {
    if (plantItemSelected) {
      (async () => {
        await setDateTime(moment().format('YYYY-MM-DD'));
        await setIsTitle('week');
        getDataPerformanceChart(
          true,
          `${moment().format('YYYY')}-${parseInt(moment().format('WW')) + 1}`,
          'week'
        );
      })();
    }
  }, [plantItemSelected, dispatch]);

  const getDataPerformanceChart = async (type: boolean, time: string, properties: string) => {
    const responseOne: ResponseData[] = await plantApi.fetchInfoPropertiesEnergy({
      id: plantItemSelected,
      type: 'output-energy',
      properties: properties,
      time: time,
    });
    const responseTwo: ResponseData[] = await plantApi.fetchInfoPropertiesEnergy({
      id: plantItemSelected,
      type: 'estimated-output-energy',
      properties: properties,
      time: time,
    });
    if (type) {
      setOutput_e(formatToday(formatArray(responseOne)));
      setEstimated_e(formatToday(formatArray(responseTwo)));
      setPerformance_ratio(
        formatToday(performanceList(formatArray(responseOne), formatArray(responseTwo)))
      );
    }
    setDataChart({
      output_e: formatArray(responseOne),
      estimated_e: formatArray(responseTwo),
      performance_ratio: performanceList(formatArray(responseOne), formatArray(responseTwo)),
    });
  };
  return (
    <div className={style.root}>
      <div className={style.active_power_chart}>
        {dataChart && (
          <ChartPerformance
            dateTime={dateTime}
            isTitle={isTitle}
            setDateTime={setDateTime}
            setIsTitle={setIsTitle}
            dataChart={dataChart}
            getDataPerformanceChart={getDataPerformanceChart}
          />
        )}
      </div>
      <div className={style.performance_info}>
        <div className={style.title_report_plant}>Today performance</div>
        <div className={style.content_item_report}>
          <div className={style.title_item}>
            <div
              className={style.item_color}
              style={{
                backgroundColor: '#ff3c2e',
              }}
            ></div>
            PV Energy Perf. Ratio
          </div>
          <div className={style.value_item} style={{ color: '#ff7900' }}>
            {performance_ratio ? `${performance_ratio.toFixed(2)} kWh` : 'NaN'}
          </div>
        </div>
        <div className={style.content_item_report}>
          <div className={style.title_item}>
            <div
              className={style.item_color}
              style={{
                backgroundColor: '#038cfc',
              }}
            ></div>
            PV Energy
          </div>
          <div className={style.value_item} style={{ color: '#000' }}>
            {output_e ? `${output_e.toFixed(2)} kWh` : 'NaN'}
          </div>
        </div>
        <div className={style.content_item_report}>
          <div className={style.title_item}>
            <div
              className={style.item_color}
              style={{
                backgroundColor: '#fcc603',
              }}
            ></div>
            Expc. PV Energy
          </div>
          <div className={style.value_item} style={{ color: '#01a84e' }}>
            {estimated_e ? `${estimated_e.toFixed(2)} kWh` : 'NaN'}
          </div>
        </div>
        <div className={style.content_item_delta}>
          <div className={style.title_item_delta}>Expc. Delta</div>
          <div
            className={style.value_item}
            style={{ color: output_e - estimated_e >= 0 ? '#61C409' : 'red' }}
          >
            {estimated_e ? `${(output_e - estimated_e).toFixed(2)} kWh` : 'NaN'}
          </div>
        </div>
      </div>
    </div>
  );
}
